/**
 * ★ Fase 59.P2 — estratto da LeadDetailPage.jsx (split componenti oversize).
 * Comportamento e data-testid INVARIATI.
 */
import React from 'react';
import { fmtRelative } from '../../lib/constants';

const CALL_OUTCOME_LABEL = {
  called: { label: 'Ha risposto', cls: 'bg-emerald-100 text-emerald-800' },
  no_answer: { label: 'Non risponde', cls: 'bg-amber-100 text-amber-800' },
  reassigned_to_claudia: { label: 'Riassegnato a Claudia', cls: 'bg-blue-100 text-blue-800' },
  abandoned: { label: 'Abbandonato', cls: 'bg-red-100 text-red-800' },
  remarketing_replied: { label: '🔥 Ha cliccato remarketing', cls: 'bg-pink-100 text-pink-800' },
};

export function CallAttemptsBlock({ lead }) {
  const cf = lead.custom_fields || {};
  const attempts = Number(cf.call_attempts || 0);
  const max = 4;
  const lastOutcome = cf.last_call_outcome;
  const outcomeMeta = lastOutcome ? CALL_OUTCOME_LABEL[lastOutcome] : null;
  const previousOwners = Array.isArray(cf.previous_owners) ? cf.previous_owners : [];
  const isReassigned = previousOwners.length > 0;
  const isAbandoned = lead.stage === 'abbandonato';
  const isRecuperabile = lead.stage === 'lead_recuperabili';

  // Color bar based on attempts
  const barColor = attempts >= 4 ? 'bg-red-500'
    : attempts >= 3 ? 'bg-orange-500'
    : attempts >= 2 ? 'bg-amber-500'
    : attempts >= 1 ? 'bg-yellow-400'
    : 'bg-slate-200';

  return (
    <div className="space-y-2 text-xs" data-testid="call-attempts-block">
      {/* Counter principale: X / 4 tentativi */}
      <div className="flex items-center gap-2">
        <span className="text-muted-foreground">Tentativi:</span>
        <span className={`font-bold text-base ${attempts >= 3 ? 'text-red-600' : 'text-foreground'}`} data-testid="call-attempts-counter">
          {attempts} / {max}
        </span>
        {outcomeMeta && (
          <span className={`ml-auto px-2 py-0.5 rounded-full text-[10px] font-semibold ${outcomeMeta.cls}`}>
            {outcomeMeta.label}
          </span>
        )}
      </div>

      {/* Progress bar visuale */}
      <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
        <div
          className={`h-full ${barColor} transition-all`}
          style={{ width: `${Math.min(100, (attempts / max) * 100)}%` }}
        />
      </div>

      {/* Ultima chiamata */}
      {cf.last_called_at && (
        <div className="text-muted-foreground">
          Ultima: {fmtRelative(cf.last_called_at)}
        </div>
      )}

      {/* Storico riassegnazioni */}
      {isReassigned && (
        <div className="mt-2 pt-2 border-t border-border space-y-1">
          <div className="text-[10px] uppercase tracking-wider text-muted-foreground font-semibold">
            Riassegnato {previousOwners.length}× — proprietari precedenti:
          </div>
          {previousOwners.map((po, i) => (
            <div key={`${po.agent_id || 'unknown'}-${po.at || i}`} className="flex items-center justify-between gap-2 text-[11px]">
              <span className="text-muted-foreground">
                {i + 1}. {po.agent_name || '—'}
              </span>
              <span className="text-amber-700">
                {po.attempts} tentativi
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Stato finale (abbandonato / recuperabili) */}
      {(isAbandoned || isRecuperabile) && (
        <div className={`mt-2 px-2 py-1.5 rounded text-[11px] font-semibold text-center ${
          isAbandoned ? 'bg-red-50 text-red-700 border border-red-200'
                      : 'bg-purple-50 text-purple-700 border border-purple-200'
        }`}>
          {isAbandoned && cf.abandoned_at && (
            <>❌ Abbandonato {fmtRelative(cf.abandoned_at)}</>
          )}
          {isRecuperabile && (
            <>🔄 In coda recovery remarketing</>
          )}
        </div>
      )}
    </div>
  );
}
